



















import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from './components/HelloWorld.vue';
import ThemeFooter from './components/ThemeFooter.vue';
import ThemeHeader from './components/ThemeHeader.vue';
import ColorPicker from './components/ColorPicker.vue';
import EditorPane from './components/EditorPane.vue';
import CodeEditor from './components/CodeEditor.vue';


import MainView from './components/MainView.vue';



@Component({
  components: {
    HelloWorld,
    ThemeHeader,
    ThemeFooter,
    MainView,
    ColorPicker,
    EditorPane,
    CodeEditor,
  },
})
export default class App extends Vue {
  colors = {
  hex: '#194d33',
  hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
  hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
  rgba: { r: 25, g: 77, b: 51, a: 1 },
  a: 1
};
}
